import { useTranslation } from 'react-i18next';

import { useRevalidator } from '@remix-run/react';

import toast from '~/utils/toast';

import { useCommunityFeedActionMutation } from './useCommunityFeedActionMutation';

export const MOVE_POST_ACTION = '/move_community_post';

interface MovePostVars {
  postId: string;
  spaceSlug: string | null;
  spaceName: string;
}

export const useMovePostMutation = () => {
  const { t } = useTranslation();
  const revalidator = useRevalidator();

  return useCommunityFeedActionMutation<MovePostVars>({
    buildRequest: ({ postId, spaceSlug }) => ({
      path: MOVE_POST_ACTION,
      fields: spaceSlug ? { post_id: postId, space_slug: spaceSlug } : { post_id: postId },
    }),
    // Revalidation refreshes the post detail page's channel label, which only changes
    // when the move succeeded — so it belongs here rather than in onSettled.
    onSuccess: (_data, { spaceName }) => {
      toast.success(t('community.action_menu.move_post_success', { channel: spaceName }));
      revalidator.revalidate();
    },
  });
};
